module.exports = __webpack_public_path__ + "static/img/projectcovermobile.698df85.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cronus/projectcovermobile.png
// module id = wbZE
// module chunks = 0